<!-- The navbar's all-three button: compact and inline, so it sits next to the status dropdown
     without the panel chrome below. -->
<button *ngIf="canReset && isAllButton" kendoButton class="resetBtn resetAllBtn resetBtn--inline"
    [disabled]="!loanApplicationId || resetting"
    (click)="confirm()">Reset All API's</button>

<!-- The per-panel button: one section only, below that panel's own Order button. -->
<div class="reset-file-apis" *ngIf="canReset && !isAllButton">
    <button kendoButton class="resetBtn" [disabled]="isStatusClosed || !loanApplicationId || resetting"
        (click)="confirm()">Reset {{ sectionLabel }}</button>
</div>

<kendo-dialog *ngIf="pendingSections.length"
    [title]="isFullReset ? 'Reset all API orders?' : 'Reset ' + sectionLabel + '?'"
    (close)="closeConfirm()" [minWidth]="250" [width]="575">
    <div class="reset-confirm">
        <p>This will clear the following on this file:</p>
        <ul>
            <li *ngFor="let label of pendingLabels">{{ label }}</li>
        </ul>
        <p *ngIf="pendingSections.includes('flood')">
            The flood certificate will also be removed from the file's documents.
        </p>
        <p *ngIf="isFullReset">
            The property address will be set back to <b>TBD</b>.
        </p>
        <p class="reset-warning">This cannot be undone.</p>
    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="confirmReset()" class="btn-proceed k-outline-none">Reset</button>
        <button kendoButton class="btn-cancel k-outline-none" (click)="closeConfirm()">Cancel</button>
    </kendo-dialog-actions>
</kendo-dialog>
